//note that some of these are also set in the server side constants (onCreateProperty function)

export default {
  appreciation: 3,
  expenses: 2,
  income: 2.5,
  capRate: 6,
  saleCost: 5,
};
